package dev.lingvo.site.pages.app.projects.slug.screenshots

import dev.lingvo.shared.screenshots.doc.Board
import dev.lingvo.shared.screenshots.doc.ScreenshotDesign
import dev.lingvo.shared.screenshots.doc.TextContent
import dev.lingvo.shared.screenshots.doc.TextLayer
import dev.lingvo.shared.screenshots.render.effectiveLayers
import dev.lingvo.shared.screenshots.render.primaryCaptionLayer

/** Preview state uses the same primary binding as export instead of assuming the slot's default key. */
internal fun designCaptionKey(design: ScreenshotDesign, board: Board, slotKey: String, locale: String): String? {
    if (design.schemaVersion < 3) return slotKey
    val page = board.pages.first { slotKey in it.slotIds }
    val primary = primaryCaptionLayer(page, effectiveLayers(page, board, locale, design.schemaVersion), page.slotIds.indexOf(slotKey))
    return when (val content = primary?.content) {
        is TextContent.Key -> content.key
        is TextContent.SlotCaption -> page.slotIds.getOrNull(content.slot)
        else -> null
    }
}

/** Every visible binding participates in preview invalidation, including device-specific caption keys. */
internal fun designCaptionKeys(design: ScreenshotDesign, board: Board, locale: String): List<String> =
    board.pages.flatMap { page -> layers(effectiveLayers(page, board, locale, design.schemaVersion))
        .filterIsInstance<TextLayer>().mapNotNull { layer -> when (val content = layer.content) {
            is TextContent.Key -> content.key
            is TextContent.SlotCaption -> page.slotIds.getOrNull(content.slot)
            is TextContent.Literal -> null
        } } }.distinct()
